import { useState } from "react";
import { Box, Typography, Button, useMediaQuery } from "@mui/material";
import { makeStyles } from "@mui/styles";
import AppleIcon from "@mui/icons-material/Apple";
import AndroidIcon from "@mui/icons-material/Android";
import Header from "../components/layout/Header";
import sorisoriBg from "../assets/products/sorisori.png";
import ownabeeBg from "../assets/products/ownabee.png";
import viralreceiptBg from "../assets/products/viralreceipt.png";
import memoriaBg from "../assets/heromemoria.png";

const PRODUCTS = [
  {
    id: "sorisori",
    index: "01",
    year: "2023",
    name: "SoriSori AI",
    domain: "소리소리에이아이",
    accent: "#FAFF69",
    accentTint:
      "radial-gradient(circle at 30% 100%, rgba(250,255,105,0.18), transparent 60%)",
    fallbackBg:
      "linear-gradient(160deg, #1c1d12 0%, #0a0a0a 60%), radial-gradient(circle at 30% 30%, rgba(250,255,105,0.18), transparent 55%)",
    bgImage: sorisoriBg,
    tagline: "목소리로 만들 수 있는 모든 것을, AI 하나로.",
    summary: "좋아하는 아티스트의 목소리로 나만의 커버 곡을 만드세요.",
    points: [
      {
        title: "정교한 음성 합성",
        desc: "실제 아티스트와 구분하기 힘든 수준의 디테일한 목소리 구현 기술을 제공합니다.",
      },
      {
        title: "방대한 모델 라이브러리",
        desc: "전 세계 유저들이 생성하고 공유하는 다양한 AI 보이스 모델을 경험할 수 있습니다.",
      },
      {
        title: "쉬운 제작 도구",
        desc: "복잡한 오디오 편집 지식 없이도 클릭 몇 번으로 나만의 커버 곡이 탄생합니다.",
      },
    ],
    ctas: [
      {
        kind: "web",
        label: "무료 체험하기",
        href: "https://app.sorisori.ai/generate-music",
      },
      {
        kind: "appstore",
        href: "https://apps.apple.com/kr/app/%EC%86%8C%EB%A6%AC%EC%86%8C%EB%A6%ACai/id6502262590",
      },
      {
        kind: "playstore",
        href: "https://play.google.com/store/apps/details?id=com.sori_mobile&pcampaignid=web_share",
      },
    ],
  },
  {
    id: "memoria",
    index: "02",
    year: "2024",
    name: "Memoria",
    domain: "메모리아",
    accent: "#F472B6",
    accentTint:
      "radial-gradient(circle at 50% 100%, rgba(244,114,182,0.20), transparent 60%)",
    fallbackBg:
      "linear-gradient(160deg, #1f1018 0%, #0a0a0a 60%), radial-gradient(circle at 40% 30%, rgba(244,114,182,0.18), transparent 55%)",
    bgImage: memoriaBg,
    tagline: "추억이 영원히 울려 퍼지는 곳.",
    summary:
      "사라져가는 목소리, 흐려지는 기억, 빛바랜 사진. 메모리아는 AI로 그 결을 다시 살려냅니다.",
    points: [
      {
        title: "음성 복원",
        desc: "단 10초의 녹음으로도 고인의 말투와 호흡까지 정교하게 되살립니다.",
      },
      {
        title: "사진·영상 복원",
        desc: "한 장의 사진에서 자연스러운 표정과 움직임을 만들어 다시 마주합니다.",
      },
      {
        title: "디지털 회고록",
        desc: "추억과 이야기를 음성·영상·텍스트로 엮어 가족과 함께 보관합니다.",
      },
    ],
    ctas: [
      { kind: "web", label: "문의하기", href: "mailto:contact@sorisori.ai" },
    ],
  },
  {
    id: "ownabee",
    index: "03",
    year: "2025",
    name: "Ownabee",
    domain: "오너비",
    accent: "#A78BFA",
    accentTint:
      "radial-gradient(circle at 70% 100%, rgba(167,139,250,0.20), transparent 60%)",
    fallbackBg:
      "linear-gradient(160deg, #1a1428 0%, #0a0a0a 60%), radial-gradient(circle at 70% 30%, rgba(167,139,250,0.20), transparent 55%)",
    bgImage: ownabeeBg,
    tagline: "우리아이의 상상 속 세계를, 책 한권에 담아보세요",
    summary:
      "아이의 창의성과 자율성, 표현의 자유를 존중하는 창작 플랫폼입니다.",
    points: [
      {
        title: "개인화 콘텐츠",
        desc: "사용자의 성향과 맥락을 이해하여 단 하나뿐인 AI 도서 콘텐츠를 생성합니다.",
      },
      {
        title: "기술적 신뢰도",
        desc: "대한민국 정부의 ‘디딤돌’ 전략 과제로 선정되어 기술력과 사업성을 인정받았습니다.",
      },
      {
        title: "지식의 재구성",
        desc: "AI가 방대한 정보를 직관적이고 몰입감 있는 독서 경험으로 재가공합니다.",
      },
    ],
    ctas: [
      {
        kind: "appstore",
        href: "https://apps.apple.com/kr/app/ownabee/id6754865508",
      },
      {
        kind: "playstore",
        href: "https://play.google.com/store/apps/details?id=com.myibook.ownabeeapp&pcampaignid=web_share",
      },
    ],
  },
  {
    id: "viralrecipe",
    index: "04",
    year: "2026",
    name: "Viral Recipe",
    domain: "바이럴 레시피",
    accent: "#FAFF69",
    accentTint:
      "radial-gradient(circle at 50% 100%, rgba(250,255,105,0.18), transparent 60%)",
    fallbackBg:
      "linear-gradient(160deg, #1c1d12 0%, #0a0a0a 60%), radial-gradient(circle at 50% 30%, rgba(250,255,105,0.16), transparent 55%)",
    bgImage: viralreceiptBg,
    tagline: "수백만 조회수로 검증된 영상, 당신의 것으로 만들어보세요",
    summary:
      "기획 없이도 터지는 광고 영상을 만드는 가장 빠른 방법. 제품 URL만 넣으면 광고가 완성됩니다.",
    points: [
      {
        title: "0초 기획",
        desc: "수백만 뷰로 검증된 포맷을 그대로 활용해, 무엇을 찍을지 고민할 필요가 없습니다.",
      },
      {
        title: "URL 입력 방식",
        desc: "판매 페이지 링크만 붙여넣으면 AI가 제품 소스를 추출해 영상에 입힙니다.",
      },
      {
        title: "성과 기반 제작",
        desc: "감에 의존하지 않고, 클릭률(CTR)이 보장된 성공 공식을 복제합니다.",
      },
    ],
    ctas: [
      {
        kind: "web",
        label: "웹사이트 바로가기",
        href: "https://viralrecipe.sorisori.ai/ko",
      },
    ],
  },
];

const N = PRODUCTS.length;
const STRIP_WIDTH = 300; // px
// 부드럽게 감속하며 멈추는 곡선(easeOutCubic). 중간이 과하게 빠르지 않음.
const EASE = "cubic-bezier(0.33, 1, 0.68, 1)";
const DURATION = "0.9s";
const OPACITY_DURATION = "0.55s";

const useStyles = makeStyles((theme) => ({
  root: {
    height: "100vh",
    overflow: "hidden",
    backgroundColor: "#0a0a0a",
    color: "#fff",
    position: "relative",
    "@media (max-width:900px)": { height: "auto", overflow: "visible" },
  },
  stage: {
    position: "relative",
    width: "100%",
    height: "100vh",
    overflow: "hidden",
    "@media (max-width:900px)": {
      height: "auto",
      display: "flex",
      flexDirection: "column",
    },
  },

  /* a single column — absolutely positioned so left/width can animate
     between the 3-up grid and the 'pushed-to-the-left strip' state */
  column: {
    position: "absolute",
    top: 0,
    height: "100vh",
    overflow: "hidden",
    cursor: "pointer",
    willChange: "left, width, opacity",
    transition: `left ${DURATION} ${EASE}, width ${DURATION} ${EASE}, opacity ${OPACITY_DURATION} ${EASE}`,
    "&::after": {
      content: '""',
      position: "absolute",
      top: 0,
      right: 0,
      bottom: 0,
      width: 1,
      background: "rgba(255,255,255,0.06)",
      pointerEvents: "none",
    },
    "&:hover $colCta": {
      borderColor: "rgba(255,255,255,0.4)",
      color: "#fff",
    },
    "@media (max-width:900px)": {
      position: "relative !important",
      left: "0 !important",
      top: "auto",
      width: "100% !important",
      height: "auto !important",
      minHeight: 0,
      opacity: "1 !important",
      pointerEvents: "auto !important",
      cursor: "default",
    },
  },
  columnSelected: { cursor: "default" },

  /* background layers (image, fallback, overlay, accent tint) */
  bgImage: {
    position: "absolute",
    inset: 0,
    width: "100%",
    height: "100%",
    objectFit: "cover",
    objectPosition: "center",
    zIndex: 0,
    userSelect: "none",
    pointerEvents: "none",
  },
  bgFallback: {
    position: "absolute",
    inset: 0,
    zIndex: 0,
  },
  bgOverlay: {
    position: "absolute",
    inset: 0,
    background:
      "linear-gradient(180deg, rgba(0,0,0,0.35) 0%, rgba(0,0,0,0.55) 50%, rgba(0,0,0,0.85) 100%)",
    zIndex: 1,
    pointerEvents: "none",
  },
  bgTint: {
    position: "absolute",
    inset: 0,
    zIndex: 2,
    pointerEvents: "none",
    opacity: 0.7,
  },

  /* content layer */
  colInner: {
    position: "relative",
    zIndex: 3,
    height: "100%",
    padding: "120px 36px 56px",
    display: "flex",
    flexDirection: "column",
    transition: `padding ${DURATION} ${EASE}`,
    "@media (max-width:1200px)": { padding: "120px 28px 48px" },
    "@media (max-width:900px)": {
      padding: "80px 28px 48px",
      minHeight: 0,
      height: "auto",
    },
  },
  colInnerStrip: {
    padding: "120px 28px 40px",
  },

  /* full content (3-up state) */
  colTopRow: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
  colIndex: {
    fontSize: 11,
    fontWeight: 700,
    letterSpacing: "2.4px",
    color: "rgba(255,255,255,0.5)",
  },
  colChapter: {
    fontSize: 11,
    fontWeight: 600,
    letterSpacing: "2.4px",
    color: "rgba(255,255,255,0.45)",
  },
  colYear: {
    fontSize: "clamp(64px, 6.5vw, 112px)",
    fontWeight: 800,
    letterSpacing: "-3px",
    lineHeight: 0.85,
    margin: 0,
    marginTop: 24,
    textShadow: "0 2px 24px rgba(0,0,0,0.4)",
  },
  colMain: {
    marginTop: "auto",
    display: "flex",
    flexDirection: "column",
    gap: 10,
    paddingBottom: 24,
    "@media (max-width:900px)": { marginTop: 24, paddingBottom: 0 },
  },
  colName: {
    fontSize: "clamp(22px, 1.8vw, 28px)",
    fontWeight: 700,
    letterSpacing: "-0.6px",
    lineHeight: 1.15,
    color: "#fff",
    margin: 0,
  },
  colDomain: {
    fontSize: 11,
    fontWeight: 600,
    letterSpacing: "1.5px",
    textTransform: "uppercase",
    color: "rgba(255,255,255,0.55)",
  },
  colTagline: {
    fontSize: 13,
    fontWeight: 500,
    lineHeight: 1.55,
    marginTop: 8,
  },
  colCta: {
    alignSelf: "flex-start",
    padding: "10px 20px",
    borderRadius: 999,
    fontSize: 12,
    fontWeight: 600,
    color: "rgba(255,255,255,0.9)",
    border: "1px solid rgba(255,255,255,0.2)",
    textTransform: "none",
    boxShadow: "none",
    background: "rgba(0,0,0,0.25)",
    backdropFilter: "blur(4px)",
    WebkitBackdropFilter: "blur(4px)",
    transition: "all 0.2s",
    "&:hover": {
      background: "rgba(0,0,0,0.4)",
      boxShadow: "none",
    },
    "@media (max-width:900px)": { marginTop: 20 },
  },
  colCtaArrow: {
    display: "inline-block",
    marginLeft: 6,
    transition: "transform 0.3s ease",
  },
  colCtaArrowExpanded: {
    transform: "rotate(90deg)",
  },

  /* mobile-only inline detail content (collapsible) */
  mobileDetail: {
    display: "none",
    "@media (max-width:900px)": {
      display: "block",
      overflow: "hidden",
      maxHeight: 0,
      opacity: 0,
      marginTop: 0,
      transition:
        "max-height 0.45s ease, opacity 0.3s ease, margin-top 0.3s ease",
    },
  },
  mobileDetailExpanded: {
    "@media (max-width:900px)": {
      maxHeight: 2000,
      opacity: 1,
      marginTop: 20,
    },
  },
  mobileDetailInner: {
    display: "flex",
    flexDirection: "column",
    gap: 20,
    padding: 24,
    borderRadius: 16,
    background: "rgba(10,10,10,0.72)",
    backdropFilter: "blur(14px)",
    WebkitBackdropFilter: "blur(14px)",
    border: "1px solid rgba(255,255,255,0.08)",
    boxShadow: "0 10px 40px rgba(0,0,0,0.35)",
  },
  mobileSummary: {
    fontSize: 14,
    lineHeight: 1.7,
    color: "rgba(255,255,255,0.82)",
    margin: 0,
  },
  mobilePoints: {
    display: "flex",
    flexDirection: "column",
    gap: 16,
    marginTop: 4,
  },
  mobilePoint: {
    paddingTop: 14,
    borderTop: "1px solid rgba(255,255,255,0.12)",
    display: "flex",
    flexDirection: "column",
    gap: 6,
  },
  mobilePointTitle: {
    fontSize: 14,
    fontWeight: 600,
    color: "#fff",
    letterSpacing: "-0.1px",
  },
  mobilePointDesc: {
    fontSize: 13,
    lineHeight: 1.6,
    color: "rgba(255,255,255,0.7)",
  },
  mobileCta: {
    alignSelf: "flex-start",
    marginTop: 8,
    padding: "12px 22px",
    borderRadius: 999,
    fontSize: 13,
    fontWeight: 600,
    color: "#0a0a0a",
    textTransform: "none",
    boxShadow: "none",
    "&:hover": { filter: "brightness(0.95)", boxShadow: "none" },
  },

  /* CTA row + store badges (shared by desktop detail & mobile detail) */
  ctaRow: {
    display: "flex",
    gap: 10,
    flexWrap: "wrap",
    alignSelf: "flex-start",
  },
  ctaRowDetail: {
    marginTop: "auto",
  },
  ctaRowMobile: {
    marginTop: 4,
  },
  storeBadge: {
    display: "inline-flex",
    alignItems: "center",
    gap: 8,
    padding: "11px 18px",
    borderRadius: 12,
    background: "#000",
    border: "1px solid rgba(255,255,255,0.22)",
    color: "#fff",
    textTransform: "none",
    fontSize: 13,
    fontWeight: 600,
    letterSpacing: "-0.1px",
    boxShadow: "none",
    minWidth: 0,
    "&:hover": {
      background: "#171717",
      borderColor: "rgba(255,255,255,0.38)",
      boxShadow: "none",
    },
    "& .MuiButton-startIcon": {
      marginRight: 2,
      marginLeft: -2,
    },
    "& .MuiButton-startIcon svg": {
      fontSize: 20,
    },
  },
  accentCta: {
    alignSelf: "flex-start",
    padding: "12px 22px",
    borderRadius: 999,
    fontSize: 13,
    fontWeight: 600,
    color: "#0a0a0a",
    textTransform: "none",
    boxShadow: "none",
    "&:hover": { filter: "brightness(0.95)", boxShadow: "none" },
  },

  /* strip view (selected column) */
  colStripBottom: {
    marginTop: "auto",
    display: "flex",
    flexDirection: "column",
    gap: 8,
  },
  stripDivider: {
    width: 32,
    height: 1,
    background: "rgba(255,255,255,0.25)",
    marginBottom: 16,
  },
  stripYearSmall: {
    fontSize: 56,
    fontWeight: 800,
    letterSpacing: "-2px",
    lineHeight: 0.9,
    margin: 0,
    marginTop: 16,
  },
  stripName: {
    fontSize: 22,
    fontWeight: 700,
    letterSpacing: "-0.5px",
    color: "#fff",
    margin: 0,
  },
  stripDomain: {
    fontSize: 11,
    fontWeight: 600,
    letterSpacing: "1.5px",
    textTransform: "uppercase",
    color: "rgba(255,255,255,0.55)",
  },

  /* detail panel — slides in from the right via transform */
  detail: {
    position: "absolute",
    top: 0,
    height: "100vh",
    overflow: "hidden",
    background: "#0a0a0a",
    transition: `transform ${DURATION} ${EASE}, opacity ${OPACITY_DURATION} ${EASE}`,
    willChange: "transform, opacity",
    "@media (max-width:900px)": { display: "none" },
  },
  detailTint: {
    position: "absolute",
    inset: 0,
    pointerEvents: "none",
    zIndex: 0,
    opacity: 0.5,
  },
  detailInner: {
    position: "relative",
    zIndex: 1,
    height: "100%",
    padding: "120px 72px 56px",
    maxWidth: 920,
    display: "flex",
    flexDirection: "column",
    gap: 18,
    "@media (max-width:900px)": { padding: "100px 28px 56px" },
  },
  backBtn: {
    alignSelf: "flex-start",
    fontSize: 12,
    fontWeight: 600,
    letterSpacing: "0.5px",
    color: "rgba(255,255,255,0.7)",
    textTransform: "none",
    padding: "8px 16px 8px 12px",
    borderRadius: 999,
    border: "1px solid rgba(255,255,255,0.12)",
    minWidth: 0,
    "&:hover": {
      background: "rgba(255,255,255,0.04)",
      color: "#fff",
      borderColor: "rgba(255,255,255,0.25)",
    },
  },
  detailMeta: {
    fontSize: 11,
    fontWeight: 700,
    letterSpacing: "2.4px",
    textTransform: "uppercase",
    color: "rgba(255,255,255,0.4)",
    marginTop: 24,
  },
  detailTitle: {
    fontSize: "clamp(36px, 4.4vw, 56px)",
    fontWeight: 700,
    letterSpacing: "-1.5px",
    lineHeight: 1.05,
    color: "#fff",
    margin: 0,
  },
  detailTagline: {
    fontSize: "clamp(16px, 1.5vw, 19px)",
    fontWeight: 500,
    lineHeight: 1.5,
    margin: 0,
  },
  detailSummary: {
    fontSize: 15,
    lineHeight: 1.75,
    color: "rgba(255,255,255,0.62)",
    margin: 0,
    maxWidth: 640,
  },
  detailPoints: {
    display: "grid",
    gridTemplateColumns: "repeat(3, 1fr)",
    gap: 28,
    marginTop: 16,
    "@media (max-width:900px)": { gridTemplateColumns: "1fr" },
  },
  detailPoint: {
    paddingTop: 14,
    borderTop: "1px solid rgba(255,255,255,0.1)",
    display: "flex",
    flexDirection: "column",
    gap: 6,
  },
  detailPointTitle: {
    fontSize: 14,
    fontWeight: 600,
    color: "#fff",
    letterSpacing: "-0.1px",
  },
  detailPointDesc: {
    fontSize: 13,
    lineHeight: 1.6,
    color: "rgba(255,255,255,0.5)",
  },
  detailCta: {
    alignSelf: "flex-start",
    marginTop: "auto",
    padding: "13px 26px",
    borderRadius: 999,
    fontSize: 13,
    fontWeight: 600,
    color: "#0a0a0a",
    textTransform: "none",
    boxShadow: "none",
    "&:hover": { filter: "brightness(0.95)", boxShadow: "none" },
  },
}));

function CtaList({
  ctas,
  accent,
  classes,
  variant,
  onClickItem,
}) {
  if (!ctas || ctas.length === 0) return null;
  const rowClass = `${classes.ctaRow} ${
    variant === "mobile" ? classes.ctaRowMobile : classes.ctaRowDetail
  }`;
  return (
    <Box className={rowClass} onClick={onClickItem}>
      {ctas.map((cta, i) => {
        if (cta.kind === "appstore") {
          return (
            <Button
              key={i}
              className={classes.storeBadge}
              href={cta.href}
              target="_blank"
              rel="noopener noreferrer"
              startIcon={<AppleIcon />}
              disableElevation
            >
              App Store
            </Button>
          );
        }
        if (cta.kind === "playstore") {
          return (
            <Button
              key={i}
              className={classes.storeBadge}
              href={cta.href}
              target="_blank"
              rel="noopener noreferrer"
              startIcon={<AndroidIcon />}
              disableElevation
            >
              Google Play
            </Button>
          );
        }
        return (
          <Button
            key={i}
            className={classes.accentCta}
            href={cta.href}
            target={cta.href?.startsWith("http") ? "_blank" : undefined}
            rel="noopener noreferrer"
            style={{ backgroundColor: accent }}
            disableElevation
          >
            {cta.label} →
          </Button>
        );
      })}
    </Box>
  );
}

function getColumnLayout(idx, selectedIdx) {
  // Returns { left, width, opacity } as CSS values.
  // - 선택된 카드만 (left:0, width:STRIP) 위치로 미끄러집니다.
  // - 나머지 카드들은 그리드 자리에 그대로 머무르고 opacity 만 0 으로 빠집니다.
  //   (밀려가며 좁아지는 모션이 없어서 어느 카드를 골라도 동일하게 차분합니다.)
  const colPercent = 100 / N;

  if (idx === selectedIdx) {
    return {
      left: "0px",
      width: `${STRIP_WIDTH}px`,
      opacity: 1,
    };
  }

  return {
    left: `${idx * colPercent}%`,
    width: `${colPercent}%`,
    opacity: selectedIdx === -1 ? 1 : 0,
  };
}

export default function Products() {
  const classes = useStyles();
  const isMobile = useMediaQuery("(max-width:900px)");
  const [selected, setSelected] = useState(null);
  const [mobileExpanded, setMobileExpanded] = useState(null);
  const selectedIdx = selected && !isMobile
    ? PRODUCTS.findIndex((p) => p.id === selected)
    : -1;
  const selectedProduct = selectedIdx >= 0 ? PRODUCTS[selectedIdx] : null;
  const detailVisible = selectedIdx >= 0;

  return (
    <Box className={classes.root}>
      <Header />

      <Box className={classes.stage}>
        {PRODUCTS.map((p, idx) => {
          const isSelected = idx === selectedIdx;
          const { left, width, opacity } = getColumnLayout(idx, selectedIdx);

          return (
            <Box
              key={p.id}
              className={`${classes.column} ${
                isSelected ? classes.columnSelected : ""
              }`}
              style={{
                left,
                width,
                opacity,
                pointerEvents: opacity === 0 ? "none" : "auto",
              }}
              onClick={() => {
                if (isMobile) {
                  setMobileExpanded((prev) => (prev === p.id ? null : p.id));
                  return;
                }
                if (selectedIdx === -1) setSelected(p.id);
              }}
            >
              {p.bgImage ? (
                <Box
                  component="img"
                  src={p.bgImage}
                  alt=""
                  className={classes.bgImage}
                />
              ) : (
                <Box
                  className={classes.bgFallback}
                  style={{ background: p.fallbackBg }}
                />
              )}
              <Box className={classes.bgOverlay} />
              <Box
                className={classes.bgTint}
                style={{ background: p.accentTint }}
              />

              <Box
                className={`${classes.colInner} ${
                  isSelected ? classes.colInnerStrip : ""
                }`}
              >
                {isSelected ? (
                  <>
                    <Box>
                      <Typography className={classes.colIndex}>
                        {p.index}
                      </Typography>
                      <Typography
                        component="div"
                        className={classes.stripYearSmall}
                        style={{ color: p.accent }}
                      >
                        {p.year}
                      </Typography>
                    </Box>
                    <Box className={classes.colStripBottom}>
                      <Box className={classes.stripDivider} />
                      <Typography className={classes.stripName}>
                        {p.name}
                      </Typography>
                      <Typography className={classes.stripDomain}>
                        {p.domain}
                      </Typography>
                    </Box>
                  </>
                ) : (
                  <>
                    <Box className={classes.colTopRow}>
                      <Typography className={classes.colIndex}>
                        {p.index}
                      </Typography>
                      <Typography className={classes.colChapter}>
                        Chapter {p.year}
                      </Typography>
                    </Box>
                    <Typography
                      component="div"
                      className={classes.colYear}
                      style={{ color: p.accent }}
                    >
                      {p.year}
                    </Typography>
                    <Box className={classes.colMain}>
                      <Typography className={classes.colName}>
                        {p.name}
                      </Typography>
                      <Typography className={classes.colDomain}>
                        {p.domain}
                      </Typography>
                      <Typography
                        className={classes.colTagline}
                        style={{ color: p.accent }}
                      >
                        “{p.tagline}”
                      </Typography>
                    </Box>
                    <Button
                      className={classes.colCta}
                      onClick={(e) => {
                        e.stopPropagation();
                        if (isMobile) {
                          setMobileExpanded((prev) =>
                            prev === p.id ? null : p.id
                          );
                        } else {
                          setSelected(p.id);
                        }
                      }}
                      disableRipple
                      disableElevation
                    >
                      {isMobile && mobileExpanded === p.id
                        ? "접기"
                        : "자세히 보기"}
                      <Box
                        component="span"
                        className={`${classes.colCtaArrow} ${
                          isMobile && mobileExpanded === p.id
                            ? classes.colCtaArrowExpanded
                            : ""
                        }`}
                      >
                        →
                      </Box>
                    </Button>
                    <Box
                      className={`${classes.mobileDetail} ${
                        mobileExpanded === p.id
                          ? classes.mobileDetailExpanded
                          : ""
                      }`}
                      aria-hidden={mobileExpanded !== p.id}
                    >
                      <Box className={classes.mobileDetailInner}>
                        <Typography className={classes.mobileSummary}>
                          {p.summary}
                        </Typography>
                        <Box className={classes.mobilePoints}>
                          {p.points.map((pt) => (
                            <Box key={pt.title} className={classes.mobilePoint}>
                              <Typography className={classes.mobilePointTitle}>
                                {pt.title}
                              </Typography>
                              <Typography className={classes.mobilePointDesc}>
                                {pt.desc}
                              </Typography>
                            </Box>
                          ))}
                        </Box>
                        <CtaList
                          ctas={p.ctas}
                          accent={p.accent}
                          classes={classes}
                          variant="mobile"
                          onClickItem={(e) => e.stopPropagation()}
                        />
                      </Box>
                    </Box>
                  </>
                )}
              </Box>
            </Box>
          );
        })}

        {/* Detail panel — always rendered, slides in from the right */}
        <Box
          className={classes.detail}
          style={{
            left: `${STRIP_WIDTH}px`,
            width: `calc(100% - ${STRIP_WIDTH}px)`,
            transform: detailVisible ? "translateX(0)" : "translateX(100%)",
            opacity: detailVisible ? 1 : 0,
            pointerEvents: detailVisible ? "auto" : "none",
          }}
          aria-hidden={!detailVisible}
        >
          {selectedProduct && (
            <>
              <Box
                className={classes.detailTint}
                style={{ background: selectedProduct.accentTint }}
              />
              <Box className={classes.detailInner}>
                <Button
                  className={classes.backBtn}
                  onClick={() => setSelected(null)}
                  disableRipple
                >
                  ← BACK
                </Button>
                <Typography className={classes.detailMeta}>
                  {selectedProduct.index} · Chapter {selectedProduct.year}
                </Typography>
                <Typography component="h1" className={classes.detailTitle}>
                  {selectedProduct.name}
                </Typography>
                <Typography
                  className={classes.detailTagline}
                  style={{ color: selectedProduct.accent }}
                >
                  “{selectedProduct.tagline}”
                </Typography>
                <Typography className={classes.detailSummary}>
                  {selectedProduct.summary}
                </Typography>
                <Box className={classes.detailPoints}>
                  {selectedProduct.points.map((pt) => (
                    <Box key={pt.title} className={classes.detailPoint}>
                      <Typography className={classes.detailPointTitle}>
                        {pt.title}
                      </Typography>
                      <Typography className={classes.detailPointDesc}>
                        {pt.desc}
                      </Typography>
                    </Box>
                  ))}
                </Box>
                <CtaList
                  ctas={selectedProduct.ctas}
                  accent={selectedProduct.accent}
                  classes={classes}
                  variant="detail"
                />
              </Box>
            </>
          )}
        </Box>
      </Box>
    </Box>
  );
}
